// FSSAIProductApproval.jsx
import React from "react";

export default function FSSAIProductApproval() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            FSSAI Product Approval
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            FSSAI Product Approval for Non-Standard Foods
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in obtaining FSSAI Product
            Approval for non-standard or proprietary food products, helping
            ensure that innovative formulations meet safety and regulatory
            expectations.
          </p>
          <p className="text-gray-700">
            From structuring technical dossiers and aligning ingredient details
            with applicable regulations to coordinating clarifications with the
            authority, the process is managed in a methodical way so your
            product can be introduced to the market with regulatory confidence.
          </p>
        </div>

        {/* Right: Image (FSSAI FOOD PRODUCT APPROVAL - food lab testing, quality control) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1279330/pexels-photo-1279330.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Technical review for FSSAI product approval"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for FSSAI Product Approval
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps compile the technical and regulatory
              data required for product approval of proprietary and non-standard
              foods, ensuring the application is complete and clearly presented.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Product formulation details, including complete ingredient list
                  and their respective quantities.
                </li>
                <li>
                  Ingredient specifications with relevant quality and safety
                  parameters as available.
                </li>
                <li>
                  Labeling information, including draft labels, claims, and
                  mandatory declarations proposed for the product.
                </li>
                <li>
                  Manufacturing process details, covering key steps, controls,
                  and any specific processing technologies used.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers focused support on product approvals, combining
              technical understanding of food standards with hands-on
              documentation and liaison experience.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Technical Understanding of Approvals
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in interpreting product approval requirements,
                  especially for proprietary, non-standard, or innovative food
                  formulations that fall outside regular standards.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Preparation
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in organizing formulation data, ingredient
                  specifications, labels, and process notes into a clear,
                  authority-ready application file.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Liaison Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Coordination with regulators for queries, clarifications, and
                  follow-ups, helping move the product approval process forward
                  efficiently.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
